import React from 'react';

import cl from './Button.module.css'

const Button = () => {
    return (
        <div className={cl.personal_banking_btn}>
            Open Account
        </div>
    );
};

export default Button;